'use client';

import { LINK } from '@constants';
import { ArrowRight, Column, Icon, Row, Typography } from '@viewup/ui';
import { useCheckLogin } from 'app/_hook';
import Image from 'next/image';

export const XmasViewupStamp = () => {
  const checkLogin = useCheckLogin();
  return (
    <Row
      alignItems='center'
      css={{ cursor: 'pointer' }}
      justifyContent='space-between'
      onClick={() => checkLogin(LINK.STAMP)}
    >
      <Row alignItems='center' gap={8} height={60}>
        <Image
          alt='attendance'
          height={62}
          src={'/images/event/xmasImages/main_stamp.png'}
          style={{ objectFit: 'contain', overflow: 'visible' }}
          unoptimized
          width={82}
        />
        <Column gap={4}>
          <Typography color='text.assistance' fontType='body2.regular'>
            매일 스탬프 모으기
          </Typography>
          <Typography fontType='body2.medium'>
            <Typography color='text.error' fontType='body2.bold'>
              X-MAS 매일 2배
            </Typography>{' '}
            포인트 적립 이벤트
          </Typography>
        </Column>
      </Row>
      <Icon size='XS' source={ArrowRight} />
    </Row>
  );
};
